import { Tooltip } from 'radix-ui';
import type { ReactNode } from 'react';
import { shortcutLabel } from '../../lib/keys';

export const TooltipProvider = Tooltip.Provider;

interface TipProps {
  label: ReactNode;
  shortcut?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: ReactNode;
}

/** Wraps a single focusable child (usually a button) with a hover/focus tooltip. */
export function Tip({ label, shortcut, side = 'bottom', children }: TipProps) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side={side}
          sideOffset={6}
          className="z-[60] flex items-center gap-2 rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-white shadow-lg animate-fade-in dark:bg-slate-100 dark:text-slate-900"
        >
          {label}
          {shortcut && (
            <kbd className="rounded bg-white/15 px-1 font-sans text-[10px] dark:bg-slate-900/10">
              {shortcutLabel(shortcut)}
            </kbd>
          )}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
